import { Box } from "@mui/material";
import { useAppGrid } from "../hooks/useAppGrid";
import { AppCategoryFilter } from "./AppCategoryFilter";
import { AppCategorySection } from "./AppCategorySection";

export const AppGrid = () => {
  const { categories, selectedCategory, setSelectedCategory, visibleCategories, getAppsForCategory } = useAppGrid();

  return (
    <Box sx={{ width: "100%" }}>
      <AppCategoryFilter categories={categories} selectedCategory={selectedCategory} onSelect={setSelectedCategory} />
      {/* <AddIntegration /> */}

      {visibleCategories.map((category) => (
        <AppCategorySection key={category} category={category} apps={getAppsForCategory(category)} />
      ))}
    </Box>
  );
};
